import { Button, Typography, TypographyProps } from "@mui/material";
import { KeyboardArrowLeft } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { useStyle } from "./style";
import { useHistory } from "react-router-dom";
import { useDeviceType } from "@hook/useDeviceType";

interface ISectionTitleProps {
    title: string;
    backButtonUrl?: string;
    subtitle?: string;
    subtitleVariant?: TypographyProps["variant"];
}

export const SectionTitle = (props: ISectionTitleProps) => {
    const { title, backButtonUrl, subtitle, subtitleVariant = "small" } = props;
    const { t } = useTranslation("common");
    const { isMobile } = useDeviceType();
    const history = useHistory();
    const { classes } = useStyle({ isMobile, hasBackButton: Boolean(backButtonUrl), hasSubtitle: Boolean(subtitle) });

    const handleBack = () => {
        backButtonUrl && history.push(backButtonUrl);
    };

    return (
        <div className={classes.root}>
            {backButtonUrl && (
                <Button className={classes.button} onClick={handleBack}>
                    <KeyboardArrowLeft className={classes.icon} />
                    {!isMobile && (
                        <Typography color="primary" variant="small">
                            {t("back")}
                        </Typography>
                    )}
                </Button>
            )}
            <Typography className={classes.heading} variant="h1">
                {title}
            </Typography>
            {subtitle && (
                <Typography align="center" variant={subtitleVariant}>
                    {subtitle}
                </Typography>
            )}
        </div>
    );
};
